module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\" modal-box modal-cancel=\"back()\" tabindex=\"-1\">\n\n    <div class=\"aside\" id=\"{{viewConfig.aside}}\">\n        <xo-aside-header ng-if=\"viewConfig.aside\" hdrtype=\"tall\" heading=\"{{viewConfig.heading}}\" sub-head='{{viewConfig.subHeading}}' add-link='{{viewConfig.addRoute}}'></xo-aside-header>\n        <div ui-view></div>\n    </div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar/template.html
// module id = ./pages/xo-sidebar/template.html
// module chunks = 1